export const isFloat = (x: number) => !!(x % 1);
